import { AuthStrategy } from './auth-strategy.type';

export const environment = {
  production: true,
  // Relative apiUrl (ADR 0010): UI/Backend laufen same-origin hinter Traefik,
  // '/api/*' wird intern zum Backend-Container geroutet. Für lokale
  // Verifikation simuliert proxy.conf.jwt.json (ng serve) dasselbe Routing.
  apiUrl: '/api/',
  nonce: '',
  authStrategy: 'jwt' as AuthStrategy,
};
